export type NotificationType = NotificationTypes;

export enum NotificationTypes {
    Error = "error",
    Info = "informational",
    Success = "success"
}
